import { oc } from "@orpc/contract";
import { z } from "zod";

const SupercedeProductSchema = z.object({
  /** `im_products_v3.key` (the SKU). Supercede edges are keyed on it. */
  productV3Key: z.string(),
  productSku: z.string().nullable(),
  /** `display_description`, NULL for most of the catalog. */
  productName: z.string().nullable(),
});

export const GetProductSupercedesInputSchema = z.object({
  productV3Key: z.string().min(1),
});

export const GetProductSupercedesResponseSchema = z.object({
  supersededBy: SupercedeProductSchema.nullable(),
  supersedes: z.array(SupercedeProductSchema),
  chain: z.array(
    SupercedeProductSchema.extend({
      isCurrent: z.boolean(),
      startStockDate: z.string().nullable(),
    }),
  ),
  rollOnHand: z.boolean().nullable(),
});

export type GetProductSupercedesInput = z.infer<
  typeof GetProductSupercedesInputSchema
>;
export type GetProductSupercedesResponse = z.infer<
  typeof GetProductSupercedesResponseSchema
>;
export type SupercedeProduct = z.infer<typeof SupercedeProductSchema>;

export const productSupercedesContracts = {
  getByProduct: oc
    .input(GetProductSupercedesInputSchema)
    .output(GetProductSupercedesResponseSchema)
    .route({
      method: "GET",
      summary: "Get a product's supersession chain",
      description:
        "For one SKU, returns the product that superseded it, the products it replaces, the full ordered supersession chain with start-stock dates, and whether on-hand rolls forward.",
    }),
} as const;
